import styles from './Triptych.module.css';

interface TriptychProps {
  words: string[];
  onChoose: (word: string) => void;
  onRefresh: () => void;
}

export function Triptych({ words, onChoose, onRefresh }: TriptychProps) {
  return (
    <section className={styles.container}>
      <p className={styles.intro}>three qualities are offered today. choose one.</p>
      <div className={styles.grid}>
        {words.map((word) => (
          <button
            key={word}
            type="button"
            className={styles.card}
            onClick={() => onChoose(word)}
          >
            <span className={styles.ornament} aria-hidden="true">
              ✦
            </span>
            <span className={styles.word}>{word}</span>
          </button>
        ))}
      </div>
      <button type="button" className={styles.refresh} onClick={onRefresh}>
        ↻ offer me three others
      </button>
    </section>
  );
}
